import BaseCom from "./common/BaseCom";

export default class AppActions extends BaseCom {
    render() {
        return <div className="app-actions app-actions-form">
            {this.props.children}
        </div>;
    }
}